import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';

import { User } from '../../../shared/models/user';
import { TooltipDirective } from '../../directives/tooltip.directive';
import { IProject, ProjectUser } from '../../../shared/models/project.model';
import { ViewerEditorIconsConstants } from '../../constants/viewer-editor-icons.constants';
import { ISwitchRole } from '../../../shared/models/switch-role.model';
import {
  IOpenTransferOwnershipConfirmationModal,
  TransferOwnershipOpenedFrom
} from '../../../shared/commands/OpenTransferOwnershipConfirmationModal';
import { elementIsShown } from '../../helpers/elements.helper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    selector: 'app-pl-invitation-member-modal',
    templateUrl: './invitation-member-modal.component.html',
    styleUrls: ['./invitation-member-modal.component.scss'],
    standalone: false
})
export class InvitationMemberModalComponent implements OnChanges {

  roleIcons = ViewerEditorIconsConstants;

  @ViewChild('invitationMemberModal') invitationMemberModalEl: ElementRef;
  @ViewChild('shareLinkInput') shareLinkInputEl: ElementRef;
  @ViewChild(TooltipDirective) tooltipEl: TooltipDirective;

  @Input() user: User;
  @Input() link: string;
  @Input() project: IProject;
  @Input() isIncomingUserEditor;

  @Output() removeUser = new EventEmitter<number>();
  @Output() selectRole = new EventEmitter<boolean>();
  @Output() unsetLink = new EventEmitter<boolean>();
  @Output() transferOwnership = new EventEmitter<IOpenTransferOwnershipConfirmationModal>();
  @Output() switchRole = new EventEmitter<ISwitchRole>();
  @Output() tenderingModalOpen = new EventEmitter<boolean>();

  openModal() {
    jQuery(this.invitationMemberModalEl.nativeElement).modal('show');
  }

  onTransferOwnership(user: ProjectUser) {
    this.transferOwnership.next({ openedFrom: TransferOwnershipOpenedFrom.projectShare, user });
  }

  removeUserFromProject(userId: number) {
    this.removeUser.next(userId);
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.invitationMemberModalEl.nativeElement).modal('hide');
    this.unsetLink.emit();
  }

  onSelectRole(isIncomingUserEditor : boolean) {
    this.selectRole.emit(isIncomingUserEditor);
  }

  onSwitchRole(canEditProject: boolean, userId: number) {
    this.switchRole.emit({canEditProject, userId})
  }

  copyInvitationLinkToClipboard(linkInput) {
    linkInput.focus();
    linkInput.select();
    document.execCommand('copy');
    this.tooltipEl.show();
  }

  modalIsShown(): boolean {
    return elementIsShown(this.invitationMemberModalEl);
  }

  openTenderingModal() {
    this.tenderingModalOpen.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if users changes role of a link ( viewer or editor ) from dropdown, we should automatically focus and click on input field
    // eslint-disable-next-line max-len
    if (changes?.link?.currentValue !== changes?.link?.previousValue && !!changes?.link?.currentValue && !!changes?.link?.previousValue && this.modalIsShown()) {
      setTimeout(() => {
        this.copyInvitationLinkToClipboard(this.shareLinkInputEl.nativeElement);
      }, 300);
    }
  }
}

